



















import { Vue, Component } from "vue-property-decorator";
import OrderForm from "@/components/orders/OrderForm.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import api from "@/getinfo-api";
import { cloneDeep } from "lodash";
import { LearningRequest } from "@/api/models/learning-request";
import OrderFormEdit from "@/components/orders/OrderFormEdit.vue";

@Component({
  components: { OrderFormEdit, CBreadCrumbs, OrderForm }
})
export default class OrderNew extends Vue {
  learningRequestForm!: LearningRequest;
  isLoading: boolean = false;

  data() {
    return {
      learningRequestForm: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "orders" },
        label: this.$tc(this.$translate.LearningRequests)
      },
      {
        label: this.$tc(this.$translate.Create)
      }
    ];
  }

  get isCreateByRequest() {
    return !!this.$route.query?.byOrder;
  }

  async checkQuery() {
    const requestIdForCopy = this.$route?.query?.byOrder;

    if (requestIdForCopy && typeof requestIdForCopy === "string") {
      await this.getRequest(requestIdForCopy!);
    }
  }

  async getRequest(id: string) {
    try {
      this.isLoading = true;
      const { data } = await api.LearningRequestApi.get(id);
      this.learningRequestForm = cloneDeep(data);
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    this.checkQuery();
  }
}
